import { useState } from "react";

import { Box, Stepper, Step, StepLabel, Grid, Button } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import SiteDetails from "./siteDetails";
import Customization from "./customization";
import TokenGatingConfiguration from "./tokenGatingConfiguration";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import DomainVerification from "./domainVerification";

const steps = [
  " Site Details",
  "Token Gating Configuration",
  "Branding",
  "Domain Verification",
];

const TokenGatingForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeStep, setActiveStep] = useState(0);
  const [selectedApplication, setSelectedApplication] = useState("");

  const [nftTokenGatingInputFields, setNftTokenGatingInputFields] = useState({
    serverUrl: "",
    domainName: "",
    isFullSiteOrPageBasedTokenGating: "",
  });

  const [pageBasedTokenGatingData, setpageBasedTokenGatingData] = useState([
    {
      pagePath: "",
      contractAddress: "",
      tokenId: "",
      nftsRequired: "",
      tokenStandard: "",
      blockChain: "",
    },
  ]);

  const [nftCustomizationDetails, setNftCustomizationDetails] = useState({
    connectWalletButtonColor: "#d9534f",
    connectWalletButtonText: "Connect Wallet",
    connectWalletButtonTextColor: "#ffffff",
    buyNFTButtonColor: "#5cb85c",
    buyNFTButtonText: "Buy NFT",
    buyNFTButtonTextColor: "#ffffff",
    restrictedContentMessageHeader: "Access to this page is restricted",
    restrictedContentMessage:
      "Please login with your crypto wallet to verify your NFT ownership",
    errorMessageHeader: "You are not authorized to access this site",
    errorMessage: "The NFT is required to view this page",
    linkToBuyNft: "https://opensea.io",
    homePageRedirectionLink: "/",
    customLogo: process.env.REACT_APP_BASE_URL + "/default-logo",
  });

  const [errorMessage, setErrorMessage] = useState({
    domainName: false,
    serverUrl: false,
    serverUrlMessage: "",
  });
  const [domainPointed, setDomainPointed] = useState(null);

  const handleDomainPointed = (value) => {
    setDomainPointed(value);
  };

  const onHandleNftCustomizationInputChange = (event) => {
    const { name, value } = event.target;
    setNftCustomizationDetails({
      ...nftCustomizationDetails,
      [name]: value,
    });
  };

  const onHandleNftTokenGatingInputChange = (event) => {
    const { name, value } = event.target;
    setNftTokenGatingInputFields({
      ...nftTokenGatingInputFields,
      [name]: value,
    });

    if (["domainName", "serverUrl"].includes(name)) {
      setErrorMessage({
        ...errorMessage,
        [name]: false,
      });
    }
  };

  const onHandleInputChangeForPageBased = (event, index) => {
    const { name, value } = event.target;
    const listOfPagePaths = [...pageBasedTokenGatingData];
    listOfPagePaths[index][name] = value;
    setpageBasedTokenGatingData(listOfPagePaths);
  };
  //removes page path field if remove button clicked dynamically
  const handleRemoveClick = (index) => {
    const listOfPagePaths = [...pageBasedTokenGatingData];
    listOfPagePaths.splice(index, 1);
    setpageBasedTokenGatingData(listOfPagePaths);
  };
  //adds more page path field if add button clicked dynamically
  const handleAddClick = () => {
    setpageBasedTokenGatingData([
      ...pageBasedTokenGatingData,
      {
        pagePath: "",
        contractAddress: "",
        tokenId: "",
        nftsRequired: "",
        tokenStandard: "",
        blockChain: "",
      },
    ]);
  };

  const onHandleCustomLogo = async (event) => {
    const data = event.target.files[0];
    if (data.size > 2 * 1000000) {
      swal({
        title: "Size is greater than 2 MB.",
        icon: "error",
      });
    }
    const { name, value } = event.target;
    const formData = new FormData();
    formData.append("image", data);
    let response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}/upload-logo`,
      data: formData,
      headers: {
        "content-type": "application/json",
      },
    });
    let imageId = response.data.response;
    let imagePath = await axios({
      method: "get",
      url: `${process.env.REACT_APP_BASE_URL}` + "/uploads/" + imageId,
    });
    imagePath = imagePath.config.url;
    imagePath = imagePath.replace(/\\/g, "/");
    setNftCustomizationDetails({
      ...nftCustomizationDetails,
      [name]: imagePath,
    });
  };

  //clears data
  const handleClearDataForPageBased = () => {
    setpageBasedTokenGatingData([
      {
        pagePath: "",
        contractAddress: "",
        tokenId: "",
        nftsRequired: "",
        tokenStandard: "",
        blockChain: "",
      },
    ]);
  };
  const onChangeSelectedApplication = (event) => {
    const application = event.target.value;
    setSelectedApplication(application);
  };

  const setupGuide = () => {
    window.open(
      "https://blockchain.miniorange.com/how-to-setup-nft-token-gating/"
    );
  };

  // Check if the single IP address is valid or not
  const IsIpAddressValid = (ipaddress) => {
    var ipformat =
      /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
    return ipformat.test(ipaddress);
  };

  const IsValidDomain = (domain) => {
    // Regular expression to match a valid domain format
    const domainPattern = /^(?!:\/\/)([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,}$/;
    return domainPattern.test(domain);
  };

  const handleNext = (event) => {
    event.preventDefault();

    if (activeStep === 0) {
      const isValidDomain = IsValidDomain(nftTokenGatingInputFields.domainName);
      const isIpAddressValid = IsIpAddressValid(
        nftTokenGatingInputFields.serverUrl
      );

      if (!isValidDomain) {
        if (!isIpAddressValid) {
          setErrorMessage({
            domainName: true,
            serverUrl: true,
            serverUrlMessage: "Please Provide a valid IP address.",
          });
          return;
        } else {
          setErrorMessage({
            ...errorMessage,
            domainName: true,
          });
          return;
        }
      } else if (!isIpAddressValid) {
        setErrorMessage({
          ...errorMessage,
          serverUrl: true,
          serverUrlMessage: "Please Provide a valid IP address.",
        });
        return;
      }

      if (
        nftTokenGatingInputFields.serverUrl === process.env.REACT_APP_IP_SERVER
      ) {
        setErrorMessage({
          ...errorMessage,
          serverUrl: true,
          serverUrlMessage:
            "Enter IP is miniOrange DApp IP address, please enter your Webiste IP address.",
        });
        return;
      }
    }

    setActiveStep((prevStep) => prevStep + 1);
    if (activeStep === steps.length - 1) {
      setActiveStep((prevStep) => prevStep - 1);
      for (let i = 0; i < pageBasedTokenGatingData.length; i++) {
        let pageBasedContent = pageBasedTokenGatingData[i];
        pageBasedContent["pagePath"] = pageBasedContent["pagePath"].trim();
        pageBasedContent["contractAddress"] =
          pageBasedContent["contractAddress"].trim();
        pageBasedContent["tokenId"] = pageBasedContent["tokenId"].trim();
        pageBasedContent["nftsRequired"] =
          pageBasedContent["nftsRequired"].trim();
        pageBasedContent["tokenStandard"] =
          pageBasedContent["tokenStandard"].trim();
        pageBasedContent["blockChain"] = pageBasedContent["blockChain"].trim();
        pageBasedTokenGatingData[i] = pageBasedContent;
      }

      let nftTokenGatingData = {
        site: location.state,
        serverUrl: nftTokenGatingInputFields.serverUrl.trim(),
        domainName: nftTokenGatingInputFields.domainName.trim(),
        isFullSiteOrPageBasedTokenGating:
          nftTokenGatingInputFields.isFullSiteOrPageBasedTokenGating,
        pageBasedTokenGatingData: pageBasedTokenGatingData,
        nftCustomizationDetails: nftCustomizationDetails,
      };

      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/nft-token-gating-configuration`,
          {
            nftTokenGatingData,
          },
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          swal({
            title: "Success!",
            text: res.data.title,
            icon: "success",
            // type: "success",
          });
          navigate("/configured-apps");
        })
        .catch((err) => {
          swal({
            title: "Oops!",
            text: err.response.data.errorMessage,
            icon: "error",
            //  type: "error",
          });
        });
    }
  };
  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const formContent = (step) => {
    switch (step) {
      case 0:
        return (
          <SiteDetails
            register={register}
            errors={errors}
            onChangeSelectedApplication={onChangeSelectedApplication}
            selectedApplication={selectedApplication}
            onHandleNftTokenGatingInputChange={
              onHandleNftTokenGatingInputChange
            }
            nftTokenGatingInputFields={nftTokenGatingInputFields}
            setupGuide={setupGuide}
            errorMessage={errorMessage}
          />
        );
      case 1:
        return (
          <TokenGatingConfiguration
            register={register}
            errors={errors}
            onHandleNftTokenGatingInputChange={
              onHandleNftTokenGatingInputChange
            }
            nftTokenGatingInputFields={nftTokenGatingInputFields}
            onHandleInputChangeForPageBased={onHandleInputChangeForPageBased}
            pageBasedTokenGatingData={pageBasedTokenGatingData}
            handleRemoveClick={handleRemoveClick}
            handleAddClick={handleAddClick}
            handleClearDataForPageBased={handleClearDataForPageBased}
          />
        );
      case 2:
        return (
          <Customization
            onHandleNftCustomizationInputChange={
              onHandleNftCustomizationInputChange
            }
            nftCustomizationDetails={nftCustomizationDetails}
            onHandleCustomLogo={onHandleCustomLogo}
          />
        );
      case 3:
        return (
          <DomainVerification
            domainPointed={domainPointed}
            handleDomainPointed={handleDomainPointed}
            domain={nftTokenGatingInputFields.domainName}
          />
        );
      default:
        return <div>404: Not Found</div>;
    }
  };

  return (
    <Box
      sx={{
        maxWidth: "1000px",
        padding: 2,
        ml: 10,
      }}
    >
      <form onSubmit={handleNext}>
        <Box
          variant="gradient"
          borderRadius="lg"
          shadow="lg"
          opacity={1}
          p={3}
          textAlign="left"
          sx={{ bgcolor: "#f2f0f0", boxShadow: 2, height: 70 }}
        >
          <Stepper
            activeStep={activeStep}
            sx={{ fontSize: 10 }}
            orientation="horizontal"
          >
            {steps.map((label, index) => (
              <Step key={index}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        <Grid container>
          <Grid item xs={12} sx={{ padding: "20px" }}>
            {formContent(activeStep)}
          </Grid>
          <Grid item xs={12}>
            <Button
              className="custom-color-button"
              size="small"
              variant="contained"
              color="info"
              disabled={activeStep === 0}
              sx={{
                ml: 11,
                mt: 1,
                mb: 3,

                boxShadow: 2,
              }}
              onClick={handleBack}
            >
              Back
            </Button>
            <Button
              className="custom-color-button"
              type="submit"
              size="small"
              variant="contained"
              color="info"
              sx={{
                ml: 2,
                mt: 1,
                mb: 3,

                boxShadow: 2,
              }}
            >
              {activeStep === steps.length - 1
                ? domainPointed
                  ? "Submit"
                  : "I'll do it later"
                : "Next"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default TokenGatingForm;
